import React from 'react';
import style from './NotFound.module.css'

export default function NotFound() {
  return (
    <div className={style.wrapper}>
      <h1>Страница не найдена!</h1>
    </div>
  )
}
